// extracted by mini-css-extract-plugin
export default {"EditProjectDialog":"EditProjectDialog_EditProjectDialog__v8c5H"};